import { httpClient } from '../httpClient'
import { type SpecSetsResponse } from '../types'

export interface SpecSetsParams {
  projectId: number
  procoreCompanyId: number
}

export async function getSpecSets(params: SpecSetsParams) {
  if (params.procoreCompanyId === 0 || params.projectId === 0) {
    throw new Error('Company Id and Project Id are required')
  }

  const { procoreCompanyId, projectId } = params

  const response = await httpClient<SpecSetsResponse>(
    `/api/v2/procore/projects/${projectId}/spec-sets?procore_company_id=${procoreCompanyId}`
  )

  return response
}
